import type {
  PlaycastMessage,
  PlaycastMessageRecordControlStart,
  PlaycastMessageRecordControlStop,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'record' as const;

export const startRecording = (
  hostId: string,
  takeId: string,
  cameraName?: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageRecordControlStart> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageRecordControlStart = {
    target,
    action: 'controlStart',
    isReply: false,
    message: { takeId, ...(cameraName ? { cameraName } : {}) },
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRecordControlStart>;
};

export const stopRecording = (
  hostId: string,
  takeId: string,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageRecordControlStop> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageRecordControlStop = {
    target,
    action: 'controlStop',
    isReply: false,
    message: { takeId },
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageRecordControlStop>;
};
